module.exports = __webpack_public_path__ + "img/phase1-2012-01.c736317d.jpg";